var map = {
	"./Bhavin_Dabhi.png": 1642,
	"./David.png": 1881,
	"./Elsa.png": 7515,
	"./Junaid.png": 7449,
	"./Mitesh.png": 3398,
	"./dashboard/Biogains.png": 1028,
	"./dashboard/Biogains1.png": 6882,
	"./dashboard/Biogains2.png": 3007,
	"./dashboard/Biogains3.png": 1867,
	"./dashboard/Biogains4.png": 9618,
	"./dashboard/Biogains5.png": 6319,
	"./dashboard/CRM_for_Financial.png": 920,
	"./dashboard/proclick.png": 6856,
	"./dashboard/shopping_admin_dashbord.png": 2545,
	"./logos/Ecoworld.png": 9102,
	"./logos/Food_place.png": 4170,
	"./logos/Kunal-Battery.png": 2835,
	"./logos/astro_logo.png": 1902,
	"./logos/barbershop.png": 5763,
	"./logos/code_infinity.png": 7790,
	"./logos/electro.png": 5479,
	"./logos/finalcial_insight.png": 4970,
	"./logos/hippo_mall.png": 3102,
	"./logos/jewelpearl.png": 1637,
	"./logos/pethouse.png": 1229,
	"./logos/studio.png": 4926,
	"./mobie_app/FoodMonkey.png": 3261,
	"./mobie_app/Nft32.1.png": 7019,
	"./mobie_app/Nft3d.png": 9771,
	"./mobie_app/Sport_app_ui.png": 6578,
	"./mobie_app/Unboarding_UI.png": 1977,
	"./mobie_app/Wallet1.png": 8830,
	"./mobie_app/Wallet2.png": 2401,
	"./mobie_app/Wallet3.png": 5709,
	"./mobie_app/Wallet4.png": 8417,
	"./mobie_app/Wallet5.png": 471,
	"./mobie_app/Wallet6.png": 2529,
	"./mobie_app/Wallet7.png": 2117,
	"./mobie_app/car_game.webp": 9300,
	"./mobie_app/car_game1.webp": 4670,
	"./mobie_app/clothwebsite.png": 3978,
	"./mobie_app/dollar_bucket.webp": 7044,
	"./mobie_app/food_orders.png": 509,
	"./mobie_app/matemagic1.png": 8728,
	"./mobie_app/matemagic2.png": 2506,
	"./mobie_app/matemagic3.png": 101,
	"./mobie_app/matemagic4.png": 1415,
	"./mobie_app/matemagic5.png": 5529,
	"./mobie_app/matemagic6.png": 4759,
	"./mobie_app/matemagic7.png": 3988,
	"./mobie_app/money_manager_app.webp": 368,
	"./mobie_app/nurse_job_1.png": 9917,
	"./mobie_app/nurse_job_2.png": 8879,
	"./mobie_app/nurse_job_3.png": 5517,
	"./mobie_app/nurse_job_4.png": 738,
	"./mobie_app/nurse_job_5.png": 4487,
	"./mobie_app/portal_app_ui.png": 9250,
	"./mobie_app/shooping.png": 5418,
	"./mobie_app/social_app.png": 6570,
	"./mobie_app/story_maker.webp": 6181,
	"./mobie_app/vpn1.png": 6243,
	"./mobie_app/vpn2.png": 3158,
	"./mobie_app/vpn3.png": 3479,
	"./mobie_app/vpn4.png": 979,
	"./mobie_app/vpn5.png": 8900,
	"./mobie_app/vpn6.png": 7202,
	"./mobie_app/webfix.png": 3746,
	"./ppt/ppt1.png": 3365,
	"./ppt/ppt2.png": 8754,
	"./roger.png": 8458,
	"./screenshot/app_screenshort_1.png": 5532,
	"./screenshot/app_screenshort_2.1.png": 9298,
	"./screenshot/app_screenshort_2.png": 724,
	"./screenshot/app_screenshort_3.1.png": 1459,
	"./screenshot/app_screenshort_3.png": 8996,
	"./services/app_screenshot.png": 5580,
	"./services/banners.png": 9576,
	"./services/blogo.png": 4853,
	"./services/dashboard.png": 6245,
	"./services/mobile_app.png": 6463,
	"./services/presentation.png": 4743,
	"./services/website_ui.png": 2988,
	"./services/wireframing.png": 3656,
	"./video_bhavin_dabhi.mp4": 5239,
	"./website/divi.png": 6091,
	"./website/divi1.png": 7864,
	"./website/lighting-website.png": 5771,
	"./website/media-agency-website.png": 5673,
	"./website/portfolio-website.png": 3314,
	"./website/product_sell.png": 8636,
	"./website/product_sell1.png": 6094,
	"./website/product_sell2.png": 6098,
	"./website/product_sell3.png": 263,
	"./website/product_sell4.png": 1174,
	"./website/product_sell_price.png": 7912,
	"./website/savoy_shopping.png": 1309,
	"./website/shopping_website.png": 6401,
	"./wireframing/recipes.png": 2014,
	"./youtube_thumbnail.png": 5544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;